import {z} from 'zod';
import {buttonValidator} from './button';
import {inputElementValidator, inputElementValidatorExtended} from './inputElement';
import {questionValidator} from './question';
import {staticTextValidator} from './staticText';
import {photoAnswerQuestionValidator} from './photoAnswerQuestion';
import {multiselectQuestionValidator} from './multiselectQuestion';
import {imageMarkupQuestionValidator} from './imageMarkupQuestion';
import {sequenceQuestionValidator} from './sequenceQuestion';
import {matchPairQuestionValidator} from './matchPairQuestion';
import {likertScaleQuestionValidator} from './likertScaleQuestion';
import {yesNoQuestionValidator} from './yesNoQuestion';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {imageGalleryValidator} from './imageGallery';
import {formValidator} from './form';
import {modalValidator} from './modalElement';
import {calculatorValidator} from './calculatorElement';
import {chatbotValidator} from './chatbotElement';
import {yesNoQuestionV2Validator} from './yesNoQuestionV2';

const knownTypes = [
    ELEMENT.STATIC_TEXT,
    ELEMENT.QUESTION,
    ELEMENT.PHOTO_ANSWER_QUESTION,
    ELEMENT.MULTI_SELECT,
    ELEMENT.IMAGE_MARKUP,
    ELEMENT.SEQUENCE_QUESTION,
    ELEMENT.MATCH_PAIR_QUESTION,
    ELEMENT.LIKERT_SCALE,
    ELEMENT.YES_NO_QUESTION,
    ELEMENT.YES_NO_QUESTION_V2,
    ELEMENT.IMAGE_GALLERY,
    ELEMENT.FORM,
    ELEMENT.MODAL,
    ELEMENT.CALCULATOR,
    ELEMENT.TEXT_INPUT,
    ELEMENT.BUTTON,
    ELEMENT.CHATBOT,
];

const unknownTypeValidator = z
    .object({
        type: z.string().refine(
            (type) => {
                const isValid = knownTypes.includes(type as ELEMENT);
                return !isValid;
            },
            (type) => ({message: `Unknown type detected: '${type}'`})
        ),
    })
    .passthrough();

export const elementValidator = z
    .discriminatedUnion('type', [
        staticTextValidator,
        questionValidator,
        photoAnswerQuestionValidator,
        multiselectQuestionValidator,
        imageMarkupQuestionValidator,
        sequenceQuestionValidator,
        matchPairQuestionValidator,
        likertScaleQuestionValidator,
        yesNoQuestionValidator,
        imageGalleryValidator,
        formValidator,
        modalValidator,
        calculatorValidator,
        yesNoQuestionV2Validator,
        buttonValidator,
        inputElementValidator,
        chatbotValidator,
    ])
    .or(unknownTypeValidator);

export const elementValidatorExtended = elementValidator.superRefine((data, ctx) => {
    if (data.type === ELEMENT.TEXT_INPUT) {
        const result = inputElementValidatorExtended.safeParse(data);
        if (!result.success) {
            result.error.errors.forEach((err) => {
                ctx.addIssue({
                    path: err.path,
                    message: err.message,
                    code: 'custom',
                });
            });
        }
    }
});
